/**
 * Funkcinės Terapijos Centras — Stuburo degeneracijos rizikos testas
 * Self-injecting widget. Embed with:
 *
 *   Place <div id="ftc-degen-checker"></div> in your blog post HTML.
 *   Load via Liquid: {{ 'ftc-degen.js' | asset_url | script_tag }}
 */
(function () {
  'use strict';

  var scriptTag = document.currentScript;
  var KLAVIYO_COMPANY_ID = scriptTag.getAttribute('data-klaviyo-id') || 'WGyTS6';
  var KLAVIYO_LIST_ID = scriptTag.getAttribute('data-list-id') || 'SBaQJL';
  var BOOKING_URL = scriptTag.getAttribute('data-booking-url') || 'https://funkcinesterapijoscentras.lt/pages/registracija';

  // ── Inject CSS ──
  var css = document.createElement('style');
  css.textContent = '' +
    '.ftcd *,.ftcd *::before,.ftcd *::after{box-sizing:border-box;margin:0;padding:0}' +
    '.ftcd{font-family:"Segoe UI",system-ui,-apple-system,sans-serif;max-width:640px;margin:40px auto;border-radius:16px;overflow:hidden;box-shadow:0 8px 32px rgba(30,126,186,.18);background:#fff}' +
    '.ftcd-header{background:linear-gradient(135deg,#1E7EBA 0%,#1a6da3 100%);padding:32px 28px 24px;text-align:center;position:relative;overflow:hidden}' +
    '.ftcd-header::before{content:"";position:absolute;top:-40%;right:-20%;width:260px;height:260px;background:rgba(0,190,195,.12);border-radius:50%}' +
    '.ftcd-header::after{content:"";position:absolute;bottom:-30%;left:-10%;width:180px;height:180px;background:rgba(255,255,255,.06);border-radius:50%}' +
    '.ftcd-header h2{color:#fff;font-size:22px;font-weight:700;margin-bottom:6px;position:relative;z-index:1;line-height:1.3}' +
    '.ftcd-header p{color:rgba(255,255,255,.85);font-size:14px;position:relative;z-index:1}' +
    '.ftcd-badge{display:inline-block;background:rgba(0,190,195,.25);color:#fff;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:1.2px;padding:4px 14px;border-radius:20px;margin-bottom:12px;position:relative;z-index:1}' +
    '.ftcd-progress-wrap{padding:0 28px;margin-top:-8px;position:relative;z-index:2}' +
    '.ftcd-progress-bar{height:6px;background:#e8f0f5;border-radius:3px;overflow:hidden;margin-top:16px}' +
    '.ftcd-progress-fill{height:100%;background:linear-gradient(90deg,#00BEC3,#1E7EBA);border-radius:3px;transition:width .5s cubic-bezier(.4,0,.2,1);width:0%}' +
    '.ftcd-step-count{text-align:center;font-size:12px;color:#7a9bb5;margin-top:8px;font-weight:500}' +
    '.ftcd-body{padding:24px 28px 28px;min-height:320px;position:relative}' +
    '.ftcd-intro{text-align:center}' +
    '.ftcd-intro-icon{width:72px;height:72px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 20px}' +
    '.ftcd-intro-icon svg{width:36px;height:36px;color:#1E7EBA}' +
    '.ftcd-intro h3{font-size:18px;color:#1a2e3d;margin-bottom:10px;font-weight:600}' +
    '.ftcd-intro p{font-size:14px;color:#5a7080;line-height:1.6;margin-bottom:8px}' +
    '.ftcd-intro-list{text-align:left;margin:16px auto;max-width:380px}' +
    '.ftcd-intro-list-item{display:flex;align-items:flex-start;gap:10px;padding:8px 0;font-size:13px;color:#3d5a6e}' +
    '.ftcd-intro-list-item .ftcd-check{width:20px;height:20px;min-width:20px;background:#00BEC3;border-radius:50%;display:flex;align-items:center;justify-content:center;margin-top:1px}' +
    '.ftcd-intro-list-item .ftcd-check svg{width:12px;height:12px;color:#fff}' +
    '.ftcd-slide{display:none;animation:ftcdFadeIn .4s ease}' +
    '.ftcd-slide.active{display:block}' +
    '@keyframes ftcdFadeIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}' +
    '.ftcd-question-num{font-size:12px;font-weight:600;color:#00BEC3;text-transform:uppercase;letter-spacing:1px;margin-bottom:8px}' +
    '.ftcd-question-text{font-size:17px;color:#1a2e3d;font-weight:600;margin-bottom:6px;line-height:1.4}' +
    '.ftcd-question-hint{font-size:13px;color:#7a9bb5;margin-bottom:24px;line-height:1.5}' +
    '.ftcd-options{display:flex;flex-direction:column;gap:10px;margin-top:4px}' +
    '.ftcd-option{display:flex;align-items:center;gap:12px;padding:14px 16px;border:2px solid #e8f0f5;border-radius:12px;cursor:pointer;transition:all .25s ease;background:#fff}' +
    '.ftcd-option:hover{border-color:#b8dce8;background:#f6fbfd}' +
    '.ftcd-option.selected{border-color:#00BEC3;background:#e6f9fa}' +
    '.ftcd-option-radio{width:22px;height:22px;min-width:22px;border-radius:50%;border:2px solid #c8d8e2;display:flex;align-items:center;justify-content:center;transition:all .25s ease}' +
    '.ftcd-option.selected .ftcd-option-radio{border-color:#00BEC3;background:#00BEC3}' +
    '.ftcd-option.selected .ftcd-option-radio::after{content:"";width:8px;height:8px;background:#fff;border-radius:50%}' +
    '.ftcd-option-text{font-size:14px;color:#2a4050;font-weight:500}' +
    '.ftcd-slider-wrap{padding:12px 0 8px}' +
    '.ftcd-slider-labels{display:flex;justify-content:space-between;margin-bottom:12px}' +
    '.ftcd-slider-label{font-size:12px;font-weight:500;padding:6px 12px;border-radius:8px;transition:all .3s ease;max-width:45%;text-align:center;line-height:1.3}' +
    '.ftcd-slider-label.left{color:#27ae60;background:#e8f8ef}' +
    '.ftcd-slider-label.right{color:#c0392b;background:#fce8e6}' +
    '.ftcd-range-track{position:relative;height:48px;display:flex;align-items:center}' +
    '.ftcd-range{-webkit-appearance:none;appearance:none;width:100%;height:8px;border-radius:4px;background:linear-gradient(90deg,#27ae60,#e0e8ed 50%,#e8a04c);outline:none;cursor:pointer}' +
    '.ftcd-range::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:28px;height:28px;border-radius:50%;background:#fff;border:3px solid #00BEC3;box-shadow:0 2px 8px rgba(0,190,195,.3);cursor:pointer;transition:transform .2s ease,box-shadow .2s ease}' +
    '.ftcd-range::-webkit-slider-thumb:hover{transform:scale(1.15);box-shadow:0 3px 14px rgba(0,190,195,.4)}' +
    '.ftcd-range::-moz-range-thumb{width:28px;height:28px;border-radius:50%;background:#fff;border:3px solid #00BEC3;box-shadow:0 2px 8px rgba(0,190,195,.3);cursor:pointer}' +
    '.ftcd-range-value{text-align:center;margin-top:8px;font-size:13px;font-weight:600;color:#1E7EBA;min-height:20px}' +
    '.ftcd-buttons{display:flex;justify-content:space-between;align-items:center;margin-top:28px;gap:12px}' +
    '.ftcd-btn{padding:12px 28px;border-radius:10px;font-size:14px;font-weight:600;cursor:pointer;border:none;transition:all .3s ease;display:inline-flex;align-items:center;gap:6px}' +
    '.ftcd-btn-primary{background:linear-gradient(135deg,#00BEC3,#00a8ad);color:#fff;box-shadow:0 4px 14px rgba(0,190,195,.3)}' +
    '.ftcd-btn-primary:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(0,190,195,.4)}' +
    '.ftcd-btn-secondary{background:transparent;color:#7a9bb5;border:2px solid #e0e8ed}' +
    '.ftcd-btn-secondary:hover{border-color:#b8d0dd;color:#5a7a90}' +
    '.ftcd-btn-large{width:100%;justify-content:center;padding:14px 28px;font-size:15px}' +
    '.ftcd-btn svg{width:16px;height:16px}' +
    '.ftcd-email-gate{text-align:center}' +
    '.ftcd-email-gate h3{font-size:18px;color:#1a2e3d;margin-bottom:8px;font-weight:600}' +
    '.ftcd-email-gate p{font-size:14px;color:#5a7080;margin-bottom:20px;line-height:1.5}' +
    '.ftcd-email-icon{width:64px;height:64px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 16px}' +
    '.ftcd-email-icon svg{width:30px;height:30px;color:#1E7EBA}' +
    '.ftcd-input-wrap{position:relative;margin-bottom:12px}' +
    '.ftcd-input{width:100%;padding:14px 16px;border:2px solid #e0e8ed;border-radius:10px;font-size:14px;font-family:inherit;color:#2a4050;outline:none;transition:border-color .3s ease;background:#fff}' +
    '.ftcd-input:focus{border-color:#00BEC3}' +
    '.ftcd-input::placeholder{color:#a8bcc8}' +
    '.ftcd-email-note{font-size:11px;color:#a0b0bb;margin-top:8px}' +
    '.ftcd-email-error{color:#e05555;font-size:12px;margin-top:4px;display:none}' +
    '.ftcd-results{text-align:center}' +
    '.ftcd-result-circle-wrap{position:relative;width:160px;height:160px;margin:0 auto 20px}' +
    '.ftcd-result-circle{width:160px;height:160px;border-radius:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;z-index:1}' +
    '.ftcd-result-circle.osteochondrosis{background:linear-gradient(135deg,#e6f5fa,#ccebf5);border:3px solid #1E7EBA}' +
    '.ftcd-result-circle.spondyloarthrosis{background:linear-gradient(135deg,#fff4e6,#ffe8cc);border:3px solid #e8a04c}' +
    '.ftcd-result-circle.osteophytes{background:linear-gradient(135deg,#f3e8fa,#e6d0f5);border:3px solid #8e44ad}' +
    '.ftcd-result-type{font-size:13px;font-weight:600;text-transform:uppercase;letter-spacing:1px;margin-bottom:2px}' +
    '.ftcd-result-label{font-size:17px;font-weight:700;text-align:center;line-height:1.2;padding:0 8px}' +
    '.ftcd-result-circle.osteochondrosis .ftcd-result-type{color:#1E7EBA}.ftcd-result-circle.osteochondrosis .ftcd-result-label{color:#165f8a}' +
    '.ftcd-result-circle.spondyloarthrosis .ftcd-result-type{color:#c46b20}.ftcd-result-circle.spondyloarthrosis .ftcd-result-label{color:#a35a18}' +
    '.ftcd-result-circle.osteophytes .ftcd-result-type{color:#8e44ad}.ftcd-result-circle.osteophytes .ftcd-result-label{color:#6c3483}' +
    '.ftcd-result-text{font-size:15px;color:#2a4050;line-height:1.6;margin-bottom:16px;max-width:480px;margin-left:auto;margin-right:auto}' +
    '.ftcd-result-detail{background:#f6f9fb;border-radius:12px;padding:16px 20px;margin-bottom:20px;text-align:left}' +
    '.ftcd-result-detail h4{font-size:14px;font-weight:600;color:#1a2e3d;margin-bottom:8px}' +
    '.ftcd-result-detail p{font-size:13px;color:#5a7080;line-height:1.5}' +
    '.ftcd-result-cta,.ftcd-result-cta:visited,.ftcd-result-cta:active,.ftcd-result-cta:hover{background:#00BEC3;color:#fff !important;padding:14px 32px;border-radius:10px;font-size:15px;font-weight:600;cursor:pointer;border:none;display:inline-flex;align-items:center;gap:8px;transition:all .3s ease;box-shadow:0 4px 14px rgba(0,190,195,.3);text-decoration:none !important}' +
    '.ftcd-result-cta:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(0,190,195,.4)}' +
    '.ftcd-result-cta svg{width:18px;height:18px}' +
    '.ftcd-disclaimer{font-size:11px;color:#a0b0bb;margin-top:16px;line-height:1.4;padding-top:12px;border-top:1px solid #eef2f5}' +
    '@media(max-width:480px){.ftcd{margin:16px 8px;border-radius:12px}.ftcd-header{padding:24px 20px 18px}.ftcd-header h2{font-size:19px}.ftcd-body{padding:20px 20px 24px}.ftcd-progress-wrap{padding:0 20px}.ftcd-slider-label{font-size:11px;padding:4px 8px}.ftcd-buttons{flex-direction:column-reverse}.ftcd-btn{width:100%;justify-content:center}}';
  document.head.appendChild(css);

  // ── SVG helpers ──
  var svgArrowRight = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6"/></svg>';
  var svgArrowLeft  = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M11 17l-5-5m0 0l5-5m-5 5h12"/></svg>';
  var svgCheck      = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4"/></svg>';
  var svgCheckSmall = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>';
  var svgSpine      = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 2v4m0 4v4m0 4v4M8 4h8M9 8h6M8 12h8M9 16h6M8 20h8"/></svg>';
  var svgMail       = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>';
  var svgCalendar   = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>';

  // ── Build HTML ──
  var html = '' +
    '<div class="ftcd-header">' +
      '<div class="ftcd-badge">Nemokamas testas</div>' +
      '<h2>Kokios stuburo problemos jums gręsia?</h2>' +
      '<p>5 žingsnių rizikos vertinimas</p>' +
    '</div>' +
    '<div class="ftcd-progress-wrap" id="ftcdProgressWrap" style="display:none;">' +
      '<div class="ftcd-progress-bar"><div class="ftcd-progress-fill" id="ftcdProgressFill"></div></div>' +
      '<div class="ftcd-step-count" id="ftcdStepCount"></div>' +
    '</div>' +
    '<div class="ftcd-body">' +

      // Intro
      '<div class="ftcd-slide active" id="ftcdIntro"><div class="ftcd-intro">' +
        '<div class="ftcd-intro-icon">' + svgSpine + '</div>' +
        '<h3>Sužinokite savo stuburo riziką</h3>' +
        '<p>Atsakykite į 5 klausimus apie savo amžių, veiklą ir simptomus — sužinokite, kokio tipo stuburo degeneracija jums labiausiai gresia.</p>' +
        '<div class="ftcd-intro-list">' +
          '<div class="ftcd-intro-list-item"><div class="ftcd-check">' + svgCheckSmall + '</div><span>Užtrunka tik 2 minutes</span></div>' +
          '<div class="ftcd-intro-list-item"><div class="ftcd-check">' + svgCheckSmall + '</div><span>Asmeninė rizikos analizė</span></div>' +
          '<div class="ftcd-intro-list-item"><div class="ftcd-check">' + svgCheckSmall + '</div><span>Prevencijos rekomendacijos</span></div>' +
        '</div>' +
        '<button class="ftcd-btn ftcd-btn-primary ftcd-btn-large" id="ftcdStartBtn">Pradėti testą ' + svgArrowRight + '</button>' +
      '</div></div>' +

      // Q1 — Age
      '<div class="ftcd-slide" id="ftcdQ1">' +
        '<div class="ftcd-question-num">1 klausimas iš 5</div>' +
        '<div class="ftcd-question-text">Koks jūsų amžius?</div>' +
        '<div class="ftcd-question-hint">Amžius yra vienas pagrindinių stuburo degeneracijos rizikos veiksnių.</div>' +
        '<div class="ftcd-options" id="ftcdO1">' +
          '<div class="ftcd-option" data-a="18" data-b="10" data-c="5"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">18\u201330 metų</div></div>' +
          '<div class="ftcd-option" data-a="25" data-b="20" data-c="15"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">31\u201345 metų</div></div>' +
          '<div class="ftcd-option" data-a="20" data-b="30" data-c="30"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">46\u201360 metų</div></div>' +
          '<div class="ftcd-option" data-a="15" data-b="35" data-c="40"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">Virš 60 metų</div></div>' +
        '</div>' +
      '</div>' +

      // Q2 — Occupation
      '<div class="ftcd-slide" id="ftcdQ2">' +
        '<div class="ftcd-question-num">2 klausimas iš 5</div>' +
        '<div class="ftcd-question-text">Kokio pobūdžio jūsų darbas?</div>' +
        '<div class="ftcd-question-hint">Darbo tipas daro didelę įtaką stuburo apkrovai ir nusidėvėjimo pobūdžiui.</div>' +
        '<div class="ftcd-options" id="ftcdO2">' +
          '<div class="ftcd-option" data-a="30" data-b="10" data-c="15"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">Sėdimas darbas (biuras, kompiuteris)</div></div>' +
          '<div class="ftcd-option" data-a="15" data-b="30" data-c="25"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">Fizinis darbas (kėlimas, statybos)</div></div>' +
          '<div class="ftcd-option" data-a="20" data-b="20" data-c="20"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">Mišrus (dalį laiko sėdint, dalį judant)</div></div>' +
          '<div class="ftcd-option" data-a="25" data-b="15" data-c="10"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">Vairavimas (ilgas sėdėjimas su vibracija)</div></div>' +
        '</div>' +
      '</div>' +

      // Q3 — Symptoms
      '<div class="ftcd-slide" id="ftcdQ3">' +
        '<div class="ftcd-question-num">3 klausimas iš 5</div>' +
        '<div class="ftcd-question-text">Kokie simptomai jus labiausiai vargina?</div>' +
        '<div class="ftcd-question-hint">Skirtingi degeneracijos tipai pasireiškia skirtingais simptomais.</div>' +
        '<div class="ftcd-options" id="ftcdO3">' +
          '<div class="ftcd-option" data-a="35" data-b="10" data-c="10"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">Nuolatinis nugaros sustingimas ir bukas skausmas</div></div>' +
          '<div class="ftcd-option" data-a="10" data-b="35" data-c="15"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">Skausmas ir girgždėjimas sąnariuose judant</div></div>' +
          '<div class="ftcd-option" data-a="10" data-b="15" data-c="35"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">Aštrus skausmas tam tikruose judesyse, tirpimas</div></div>' +
          '<div class="ftcd-option" data-a="20" data-b="20" data-c="20"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">Ryto sustingimas, kuris praeina pajudėjus</div></div>' +
        '</div>' +
      '</div>' +

      // Q4 — Activity level slider
      '<div class="ftcd-slide" id="ftcdQ4">' +
        '<div class="ftcd-question-num">4 klausimas iš 5</div>' +
        '<div class="ftcd-question-text">Koks jūsų fizinio aktyvumo lygis?</div>' +
        '<div class="ftcd-question-hint">Reguliarus judėjimas padeda stabdyti degeneraciją, o sėdimas gyvenimo būdas — spartina.</div>' +
        '<div class="ftcd-slider-wrap"><div class="ftcd-slider-labels"><span class="ftcd-slider-label left">Labai aktyvus</span><span class="ftcd-slider-label right">Sėdimas gyvenimas</span></div>' +
        '<div class="ftcd-range-track"><input type="range" class="ftcd-range" id="ftcdR4" min="0" max="100" value="50"></div>' +
        '<div class="ftcd-range-value" id="ftcdV4"></div></div>' +
      '</div>' +

      // Q5 — Spine area
      '<div class="ftcd-slide" id="ftcdQ5">' +
        '<div class="ftcd-question-num">5 klausimas iš 5</div>' +
        '<div class="ftcd-question-text">Kurioje stuburo srityje jaučiate daugiausia problemų?</div>' +
        '<div class="ftcd-question-hint">Skirtingos stuburo sritys linkusios į skirtingus degeneracijos tipus.</div>' +
        '<div class="ftcd-options" id="ftcdO5">' +
          '<div class="ftcd-option" data-a="30" data-b="15" data-c="20"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">Kaklo sritis (kaklas, pečiai)</div></div>' +
          '<div class="ftcd-option" data-a="15" data-b="30" data-c="15"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">Krūtinės sritis (vidurinė dalis)</div></div>' +
          '<div class="ftcd-option" data-a="25" data-b="20" data-c="30"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">Juosmens sritis (apatinė nugaros dalis)</div></div>' +
          '<div class="ftcd-option" data-a="15" data-b="25" data-c="25"><div class="ftcd-option-radio"></div><div class="ftcd-option-text">Kryžkaulis (dubens sritis)</div></div>' +
        '</div>' +
      '</div>' +

      // Email gate
      '<div class="ftcd-slide" id="ftcdEmail"><div class="ftcd-email-gate">' +
        '<div class="ftcd-email-icon">' + svgMail + '</div>' +
        '<h3>Jūsų rizikos analizė paruošta!</h3>' +
        '<p>Įveskite savo el. paštą ir gaukite detalią analizę bei prevencijos rekomendacijas tiesiai į pašto dėžutę.</p>' +
        '<div class="ftcd-input-wrap"><input type="email" class="ftcd-input" id="ftcdEmailInput" placeholder="jūsų@elpaštas.lt"><div class="ftcd-email-error" id="ftcdEmailError">Įveskite teisingą el. pašto adresą</div></div>' +
        '<button class="ftcd-btn ftcd-btn-primary ftcd-btn-large" id="ftcdEmailBtn">Gauti rezultatus ' + svgCheck + '</button>' +
        '<div class="ftcd-email-note">Galėsite bet kada atsisakyti naujienlaiškio.</div>' +
      '</div></div>' +

      // Results
      '<div class="ftcd-slide" id="ftcdResults"><div class="ftcd-results">' +
        '<div class="ftcd-result-circle-wrap"><div class="ftcd-result-circle" id="ftcdResultCircle"><div class="ftcd-result-type" id="ftcdResultType"></div><div class="ftcd-result-label" id="ftcdResultLabel"></div></div></div>' +
        '<div class="ftcd-result-text" id="ftcdResultText"></div>' +
        '<div class="ftcd-result-detail" id="ftcdResultDetail"><h4 id="ftcdDetailTitle"></h4><p id="ftcdDetailText"></p></div>' +
        '<a class="ftcd-result-cta" href="' + BOOKING_URL + '" target="_blank" id="ftcdBookingBtn">Registruotis konsultacijai ' + svgCalendar + '</a>' +
        '<div class="ftcd-disclaimer">Šis klausimynas yra informacinio pobūdžio ir nepakeičia profesionalaus gydytojo ar kineziterapeuto konsultacijos. Visada kreipkitės į specialistą dėl tikslios diagnozės.</div>' +
      '</div></div>' +

      // Nav buttons
      '<div class="ftcd-buttons" id="ftcdNav" style="display:none;">' +
        '<button class="ftcd-btn ftcd-btn-secondary" id="ftcdBtnBack">' + svgArrowLeft + ' Atgal</button>' +
        '<button class="ftcd-btn ftcd-btn-primary" id="ftcdBtnNext">Kitas ' + svgArrowRight + '</button>' +
      '</div>' +

    '</div>';

  // ── Mount ──
  var target = document.getElementById('ftc-degen-checker');
  if (!target) return;
  var root = document.createElement('div');
  root.className = 'ftcd';
  root.id = 'ftcdChecker';
  root.innerHTML = html;
  target.appendChild(root);

  // ── State ──
  // Scores: a = osteochondrosis, b = spondyloarthrosis, c = osteophytes
  var currentStep = 0;
  var scores = { a: 0, b: 0, c: 0 };
  var sliderVal = 50;
  var optionQs = [1, 2, 3, 5];
  var totalSteps = 5;

  var nav          = document.getElementById('ftcdNav');
  var progressWrap = document.getElementById('ftcdProgressWrap');
  var backBtn      = document.getElementById('ftcdBtnBack');
  var nextBtn      = document.getElementById('ftcdBtnNext');
  var progressFill = document.getElementById('ftcdProgressFill');
  var stepCount    = document.getElementById('ftcdStepCount');

  // Track which option was selected per question for back navigation
  var selectedOpts = {};

  // ── Event listeners ──
  document.getElementById('ftcdStartBtn').addEventListener('click', function () {
    currentStep = 1; showStep();
  });
  nextBtn.addEventListener('click', function () {
    // Only used for slider step (Q4)
    currentStep = currentStep < totalSteps ? currentStep + 1 : 6;
    showStep();
  });
  backBtn.addEventListener('click', function () {
    currentStep = currentStep === 6 ? totalSteps : Math.max(1, currentStep - 1);
    showStep();
  });
  document.getElementById('ftcdEmailBtn').addEventListener('click', submitEmail);

  // Slider Q4
  document.getElementById('ftcdR4').addEventListener('input', function () { updateSlider(); });

  // Option cards — multi-axis scoring (auto-advance)
  optionQs.forEach(function (q) {
    document.querySelectorAll('#ftcdO' + q + ' .ftcd-option').forEach(function (el) {
      el.addEventListener('click', function () {
        // Remove previous selection score
        if (selectedOpts[q]) {
          scores.a -= parseInt(selectedOpts[q].getAttribute('data-a'));
          scores.b -= parseInt(selectedOpts[q].getAttribute('data-b'));
          scores.c -= parseInt(selectedOpts[q].getAttribute('data-c'));
        }
        // Add new
        scores.a += parseInt(el.getAttribute('data-a'));
        scores.b += parseInt(el.getAttribute('data-b'));
        scores.c += parseInt(el.getAttribute('data-c'));
        selectedOpts[q] = el;
        el.parentElement.querySelectorAll('.ftcd-option').forEach(function (s) { s.classList.remove('selected'); });
        el.classList.add('selected');
        // Auto-advance after brief visual feedback
        setTimeout(function () {
          currentStep = q < totalSteps ? q + 1 : 6;
          showStep();
        }, 350);
      });
    });
  });

  // ── Functions ──
  function updateSlider() {
    var slider = document.getElementById('ftcdR4');
    sliderVal = parseInt(slider.value);
    var valEl = document.getElementById('ftcdV4');
    if (sliderVal < 25) valEl.textContent = 'Labai aktyvus';
    else if (sliderVal < 50) valEl.textContent = 'Vidutiniškai aktyvus';
    else if (sliderVal === 50) valEl.textContent = 'Vidutinis';
    else if (sliderVal < 75) valEl.textContent = 'Mažai aktyvus';
    else valEl.textContent = 'Sėdimas gyvenimo būdas';
  }

  function getResult() {
    // Add slider influence: high inactivity boosts osteochondrosis and spondyloarthrosis
    var finalA = scores.a + Math.round(sliderVal * 0.3);
    var finalB = scores.b + Math.round(sliderVal * 0.25);
    var finalC = scores.c + Math.round(sliderVal * 0.15);
    if (finalA >= finalB && finalA >= finalC) return 'osteochondrosis';
    if (finalB >= finalA && finalB >= finalC) return 'spondyloarthrosis';
    return 'osteophytes';
  }

  function submitEmail() {
    var emailInput = document.getElementById('ftcdEmailInput');
    var email = emailInput.value.trim();
    var errorEl = document.getElementById('ftcdEmailError');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.style.display = 'block';
      emailInput.style.borderColor = '#e05555';
      return;
    }
    errorEl.style.display = 'none';
    emailInput.style.borderColor = '#00BEC3';
    sendToKlaviyo(email);
    currentStep = 7;
    showStep();
    computeResults();
  }

  function sendToKlaviyo(email) {
    if (!KLAVIYO_COMPANY_ID || !KLAVIYO_LIST_ID) return;
    var resultType = getResult();

    var subData = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Spine Degeneration Widget',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email },
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
        }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(subData)
    }).then(function (r) {
      console.log('[FTC Degen] Klaviyo subscribe:', r.status);
      if (!r.ok) return r.text().then(function (b) { console.error('[FTC Degen] Subscribe error:', b); });
    }).catch(function (e) {
      console.error('[FTC Degen] Subscribe fetch error:', e);
    });
var subData2={data:{type:'subscription',attributes:{custom_source:'Spine Degeneration Widget',profile:{data:{type:'profile',attributes:{email:email},subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}},relationships:{list:{data:{type:'list',id:'VfJCJm'}}}}}};
fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+KLAVIYO_COMPANY_ID,{method:'POST',headers:{'Content-Type':'application/json','revision':'2024-10-15'},body:JSON.stringify(subData2)});
resultType = {osteochondrosis:'Osteochondrozė',spondyloarthrosis:'Spondiloartrozė',osteophytes:'Osteofitai'}[resultType] || resultType;
var profileData = {
      data: {
        type: 'profile',
        attributes: {
          email: email,
          properties: {
            degen_type_result: resultType,
            degen_type_date: new Date().toISOString()
          }
        }
      }
    };
    fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(profileData)
    }).then(function (r) {
      console.log('[FTC Degen] Klaviyo profile:', r.status);
      if (!r.ok) return r.text().then(function (b) { console.error('[FTC Degen] Profile error:', b); });
    }).catch(function (e) {
      console.error('[FTC Degen] Profile fetch error:', e);
    });
  }

  function computeResults() {
    var result = getResult();
    var circle = document.getElementById('ftcdResultCircle');
    var typeEl = document.getElementById('ftcdResultType');
    var labelEl = document.getElementById('ftcdResultLabel');
    var textEl = document.getElementById('ftcdResultText');
    var dTitle = document.getElementById('ftcdDetailTitle');
    var dText = document.getElementById('ftcdDetailText');
    circle.className = 'ftcd-result-circle';

    if (result === 'osteochondrosis') {
      circle.classList.add('osteochondrosis');
      typeEl.textContent = 'Didžiausia rizika';
      labelEl.textContent = 'Osteochondrozė';
      textEl.textContent = 'Jūsų amžius, darbo pobūdis ir simptomai rodo, kad jums gali grėsti stuburo osteochondrozė — tarpslankstelinių diskų nusidėvėjimas. Tai dažniausia stuburo degeneracijos forma.';
      dTitle.textContent = 'Kas yra osteochondrozė?';
      dText.textContent = 'Osteochondrozė — tai diskų dehidratacija ir aukščio praradimas. Dažniausiai pasireiškia žmonėms, kurie daug sėdi ar turi netaisyklingą laikyseną. Gera žinia — kineziterapija, stuburo stabilizacijos pratimai ir darbo vietos ergonomikos korekcija gali žymiai sulėtinti procesą ir sumažinti simptomus.';
    } else if (result === 'spondyloarthrosis') {
      circle.classList.add('spondyloarthrosis');
      typeEl.textContent = 'Didžiausia rizika';
      labelEl.textContent = 'Spondiloartrozė';
      textEl.textContent = 'Jūsų atsakymai rodo, kad jums gali grėsti spondiloartrozė — stuburo facetinių sąnarių nusidėvėjimas. Tai dažna problema vyresniame amžiuje ar esant didelei fizinei apkrovai.';
      dTitle.textContent = 'Kas yra spondiloartrozė?';
      dText.textContent = 'Spondiloartrozė — tai stuburo mažųjų (facetinių) sąnarių artrozė. Ji dažniau pasireiškia žmonėms, kurie patiria pasikartojančius stuburo judesius ar fizinę apkrovą. Individuali kineziterapijos programa padeda sustiprinti stabilizuojančius raumenis, pagerinti judrumą ir sumažinti skausmą sąnariuose.';
    } else {
      circle.classList.add('osteophytes');
      typeEl.textContent = 'Didžiausia rizika';
      labelEl.textContent = 'Osteofitai';
      textEl.textContent = 'Jūsų atsakymai rodo, kad gali grėsti osteofitų (kaulinių išaugų) formavimasis. Tai organizmo bandymas stabilizuoti nusidėvėjusį stuburą, tačiau osteofitai gali pradėti spausti nervus.';
      dTitle.textContent = 'Kas yra osteofitai?';
      dText.textContent = 'Osteofitai — tai kaulinės ataugos ant slankstelių kraštų. Jie formuojasi kaip organizmo reakcija į stuburo nestabilumą ar lėtinį dirginimą. Nors patys savaime nėra pavojingi, jie gali spausti nervus ir sukelti skausmą. Funkcinė terapija padeda pagerinti stuburo biomechaniką ir sumažinti tolesnį osteofitų formavimąsi.';
    }
  }

  function showStep() {
    var slides = document.querySelectorAll('#ftcdChecker .ftcd-slide');
    slides.forEach(function (s) { s.classList.remove('active'); });

    if (currentStep === 0) {
      document.getElementById('ftcdIntro').classList.add('active');
      nav.style.display = 'none'; progressWrap.style.display = 'none';
    } else if (currentStep >= 1 && currentStep <= totalSteps) {
      document.getElementById('ftcdQ' + currentStep).classList.add('active');
      progressWrap.style.display = 'block';
      progressFill.style.width = Math.round((currentStep / totalSteps) * 100) + '%';
      stepCount.textContent = currentStep + ' iš ' + totalSteps + ' klausimų';
      // Slider step (Q4): show Next; Option steps: auto-advance, hide Next
      if (currentStep === 4) {
        nav.style.display = 'flex';
        nextBtn.style.display = '';
        backBtn.style.visibility = 'visible';
        nextBtn.innerHTML = 'Kitas ' + svgArrowRight;
        updateSlider();
      } else {
        nav.style.display = currentStep === 1 ? 'none' : 'flex';
        nextBtn.style.display = 'none';
        backBtn.style.visibility = 'visible';
      }
    } else if (currentStep === 6) {
      document.getElementById('ftcdEmail').classList.add('active');
      nav.style.display = 'flex'; progressWrap.style.display = 'block';
      progressFill.style.width = '100%';
      stepCount.textContent = 'Paskutinis žingsnis';
      backBtn.style.visibility = 'visible';
      nextBtn.style.display = 'none';
    } else if (currentStep === 7) {
      document.getElementById('ftcdResults').classList.add('active');
      nav.style.display = 'none'; progressWrap.style.display = 'none';
    }
  }

})();